import { useState, useRef, useEffect } from 'react';

const InfoButton = ({
  infoText,
  infoContent,
  type = 'info',
  align = 'left',
}) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const containerRef = useRef(null);
  const tooltipContent = infoContent ?? infoText;

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (containerRef.current && !containerRef.current.contains(e.target)) {
        setShowTooltip(false);
      }
    };

    document.addEventListener('touchstart', handleOutsideClick, {
      passive: true,
    });

    return () => {
      document.removeEventListener('touchstart', handleOutsideClick);
    };
  }, []);

  return (
    <div
      className="info-button-container"
      ref={containerRef}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div
        className={`info-button ${type !== 'info' ? type : ''}`}
        onTouchStart={() => setShowTooltip((prev) => !prev)}
      >
        i
      </div>
      {showTooltip && (
        <div className={`tooltip ${type} ${align}`}>{tooltipContent}</div>
      )}
    </div>
  );
};

export default InfoButton;
